import * as React from 'react'
import type { SVGProps } from 'react'
export interface BoltIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * bolt
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const BoltIcon = (props: BoltIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 3v7h6l-8 11v-7H5z"
      />
    </svg>
  )
}
